
export default function convertToREM  (init) {
    return(
        `${init / 16}rem`
    )
}